import { useWhereAmIStore } from "@/stores/useWhereAmIStore";
import type { WorkflowRecommendation } from "@/lib/workflowAdvisor";

// Compact on-page "Next step" card: the single recommended action + its "why",
// with an escape hatch to the full map overlay for the cross-phase picture and
// alternatives. Deliberately NOT a full alternatives list — the Analyze/Build
// idle panels already list every surface below this card, so inlining the
// advisor's alternatives here would just duplicate them. The map overlay
// (WorkflowPanel → RecommendationList) is the one place that shows alternatives.

interface Props {
  rec: WorkflowRecommendation;
  onAct: (rec: WorkflowRecommendation) => void;
}

export function NextStepCard({ rec, onAct }: Props) {
  return (
    <div className="rounded-lg border border-primary/30 bg-gradient-to-b from-primary/15 to-primary/5 px-4 py-4">
      <div className="mb-1 text-[10px] font-bold uppercase tracking-wider text-primary">
        Next step
      </div>
      <div className="mb-1 text-base font-bold leading-tight">{rec.title}</div>
      <p className="mb-3 text-sm leading-relaxed text-muted-foreground">{rec.rationale}</p>
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={() => onAct(rec)}
          data-testid="next-step-cta"
          className="inline-flex h-8 items-center rounded-md bg-primary px-3 text-xs font-semibold text-[#11111b]"
        >
          {rec.title} →
        </button>
        <button
          type="button"
          onClick={() => useWhereAmIStore.getState().open()}
          className="text-[11px] text-muted-foreground underline-offset-2 hover:text-primary hover:underline"
        >
          Other options ↗
        </button>
      </div>
    </div>
  );
}
